import { compose } from 'recompose';

import ChannelsItem from './channelsItem';

const enhance = compose();

export default enhance(ChannelsItem);
